import { Divider, Input, Row, Select, Space, Spin } from "antd";
import { Button } from "../Button";
import { PlusOutlined } from "@ant-design/icons";
import { useState, useRef, useLayoutEffect } from "react";
import classNames from "classnames";
import { BaseOptionType, OptionProps } from "antd/es/select";

type NewItemProps = {
  placeholder: string;
  addNewItem: (item: string) => void;
  addButtonText: string;
};

type SelectInputProps = {
  placeholder: string;
  dropdownOpen: boolean;
  setDropdownOpen: (open: boolean) => void;
  allowClear?: boolean;
  showSearch?: boolean;
  onSearch?: (query: string) => void;
  isFetching: boolean;
  mode?: "multiple" | "tags";
  value: string | string[];
  onchange: (value: string | string[]) => void;
  newItem?: NewItemProps;
  options: {
    value: string;
    label: string;
  }[];
  classNameProps?: string[];
  filterOption?: boolean;
};
const SelectInput = ({
  placeholder,
  dropdownOpen,
  setDropdownOpen,
  allowClear = true,
  showSearch = true,
  onSearch,
  isFetching,
  options,
  mode,
  value,
  onchange,
  newItem,
  classNameProps,
  filterOption,
}: SelectInputProps) => {
  const [newItemValue, setNewItemValue] = useState<string>("");

  return (
    <Select
      className={classNames(classNameProps)}
      open={dropdownOpen}
      onDropdownVisibleChange={setDropdownOpen}
      showSearch={showSearch}
      mode={mode}
      onSearch={(value) => onSearch && onSearch(value)}
      placeholder={placeholder}
      optionFilterProp={filterOption ? "label" : "children"}
      allowClear={allowClear}
      options={options}
      value={value}
      onChange={onchange}
      style={{ width: "100%" }}
      dropdownStyle={{ minWidth: 600 }}
      dropdownRender={(menu) => {
        return isFetching ? (
          <div>
            <Divider style={{ margin: "8px 0" }} />
            <Row
              style={{
                margin: 10,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spin style={{ width: 30, height: 30 }} />
            </Row>
          </div>
        ) : (
          <div>
            {menu}
            {newItem && (
              <>
                <Divider style={{ margin: 8 }} />
                <Space
                  style={{
                    padding: "0 8px 4px",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Input
                    placeholder={newItem?.placeholder}
                    value={newItemValue}
                    onChange={(e) => setNewItemValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && newItemValue) {
                        e.stopPropagation();

                        e.preventDefault();
                        newItem?.addNewItem(newItemValue);
                      }
                    }}
                    style={{ width: 300 }}
                  />
                  {/* Hidden span for measuring text width */}

                  <Button
                    type="text"
                    icon={<PlusOutlined />}
                    disabled={!newItem}
                    onClick={() => {
                      newItem?.addNewItem(newItemValue);
                      setDropdownOpen(false);
                      setNewItemValue("");
                    }}
                  >
                    {newItem?.addButtonText}
                  </Button>
                </Space>
              </>
            )}
          </div>
        );
      }}
      filterOption={filterOption ? true : false}
    ></Select>
  );
};

export default SelectInput;
